import { isDefined } from './helpers';
import Glightbox from 'glightbox';

export function initLightbox() {
    const lightbox = Glightbox({});
}
